import React from "react";
import { Character } from "../../../types";
import CharacterInputField from "./CharacterInputField";

interface OtpSubmitBaseProps {
  playerCharacters: Character[];
  characterNames: Map<number, string>;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => string;
  showMaturitySelector: boolean;
  mature: boolean;
  onMatureChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maturityLabelText: string;
  eighteenPlusText: string;
  allAgesText: string;
}

const OtpSubmitBase: React.FunctionComponent<OtpSubmitBaseProps> = ({
  playerCharacters,
  characterNames,
  onNameChange,
  showMaturitySelector,
  mature,
  onMatureChange,
  maturityLabelText,
  eighteenPlusText,
  allAgesText,
}) => {
  return (
    <div className="flex-1 flex flex-col flex-nowrap justify-evenly items-center">
      {playerCharacters.map((v, idx) => (
        <div
          className={"flex flex-col mx-1 space-y-1 max-w-full"}
          key={`otp-char-field-${v.id}`}
        >
          <CharacterInputField
            character={v}
            index={idx}
            value={characterNames.get(v.id) ?? ""}
            onNameChange={onNameChange}
            className="px-4"
          />
        </div>
      ))}

      {showMaturitySelector && (
        <div className={"self-stretch flex flex-row"}>
          <div
            className={"flex-grow flex flex-row items-center justify-evenly"}
          >
            <div
              className={
                "text-2xl mr-2 bg-gray-drk shadow-basic p-4 text-center"
              }
            >
              {maturityLabelText}
            </div>

            <div className={"flex flex-row items-center"}>
              <div className={"flex flex-row items-stretch cursor-pointer"}>
                <input
                  id="mature-yes"
                  name="mature"
                  type="radio"
                  value="true"
                  onChange={onMatureChange}
                  checked={mature}
                />
                <label
                  className="flex justify-center items-center mx-1 leading-none rounded-none"
                  htmlFor="mature-yes"
                >
                  {eighteenPlusText}
                </label>
                <input
                  id="mature-no"
                  name="mature"
                  type="radio"
                  value="false"
                  onChange={onMatureChange}
                  checked={!mature}
                />
                <label
                  className="flex justify-center items-center mx-1 leading-none  rounded-none"
                  htmlFor="mature-no"
                >
                  {allAgesText}
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtpSubmitBase;
